var map = {
	"./pc-module-catalogue-1.vue": 7542,
	"./pc-module-catalogue-2.vue": 44085,
	"./pc-module-catalogue-3.vue": 22510,
	"./pc-module-catalogue-4.vue": 56484,
	"./pc-module-catalogue-5.vue": 6255,
	"./pc-module-catalogue-6.vue": 4667
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5488;